// extracted by mini-css-extract-plugin
export default {"draggablePanel":"index_draggablePanel__-hfA2","top":"index_top__ediNn","close":"index_close__v3Bpf","main":"index_main__1DiYr","show":"index_show__xNEfY","hide":"index_hide__ppBEk"};